// import React, { useEffect, useState } from "react";
// import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, pdf } from "@react-pdf/renderer";
// import { Spinner } from "reactstrap";
// import { getAccTrans } from "../../../store/accTrans/action";
// import { useDispatch, useSelector } from "react-redux";
// import handleValidDate from "../../../helpers/utils/handleValidDate";

// const currencyFormat = (num) => {
//   return parseFloat(num || 0).toLocaleString("id-ID");
// };

// const formatSaldo = (saldo) => {
//   if (saldo < 0) {
//     return `(${currencyFormat(Math.abs(saldo))})`;
//   }
//   return currencyFormat(saldo);
// };

// const BalanceSheetPDF = ({ data }) => {
//   return (
//     <Document>
//       <Page size="A4" orientation="landscape" style={{ padding: 30, paddingTop: 128, paddingBottom: 110, fontSize: 10, fontFamily: "Helvetica" }} wrap>
//         <View fixed style={{ position: "absolute", top: 30, left: 30, right: 30, fontWeight: "bold" }}>
//           <View style={{ marginBottom: 20 }}>
//             <Text>PT HIKMAH ALAM SENTOSA</Text>
//             <Text>NERACA</Text>
//             <Text>per tanggal 31/12/2024</Text>
//             <Text style={{ fontSize: 8 }}>(dalam IDR)</Text>
//           </View>
//           <View
//             style={{
//               flexDirection: "row",
//               width: "100%",
//               padding: 6,
//               backgroundColor: "#00c7ff",
//               color: "#ffffff",
//               marginBottom: 4,
//             }}
//           >
//             <View style={{ width: "12%" }}>
//               <Text>Tanggal</Text>
//             </View>

//             <View style={{ width: "18%" }}>
//               <Text>Nomor</Text>
//             </View>

//             <View style={{ width: "34%" }}>
//               <Text>Keterangan</Text>
//             </View>

//             <View style={{ width: "12%", textAlign: "right" }}>
//               <Text>Debit</Text>
//             </View>

//             <View style={{ width: "12%", textAlign: "right" }}>
//               <Text>Kredit</Text>
//             </View>

//             <View style={{ width: "12%", textAlign: "right" }}>
//               <Text>Saldo</Text>
//             </View>
//           </View>
//         </View>

//         <View>
//           {data.map((account) => {
//             let temp_saldo = account.close_balance;

//             return (
//               <View key={account.id} wrap>
//                 <View
//                   style={{
//                     padding: 8,
//                     backgroundColor: "#f1f1f1",
//                   }}
//                 >
//                   <Text style={{ fontWeight: "bold" }}>
//                     ({account.code}) {account.name.trimStart()}
//                   </Text>
//                 </View>

//                 <View
//                   style={{
//                     flexDirection: "row",
//                     width: "100%",
//                     padding: 8,
//                     borderBottomWidth: 1,
//                     borderBottomColor: "#e0e0e0",
//                   }}
//                 >
//                   <View style={{ width: "12%" }}>
//                     <Text style={{ fontWeight: "bold" }}>{handleValidDate(account?.closeat ?? "", "DD/MM/YYYY")}</Text>
//                   </View>

//                   <View style={{ width: "18%" }}>
//                     <Text style={{ fontWeight: "bold" }}>Saldo Awal</Text>
//                   </View>

//                   <View style={{ width: "34%" }}>
//                     <Text></Text>
//                   </View>

//                   <View style={{ width: "12%", textAlign: "right" }}>
//                     <Text></Text>
//                   </View>

//                   <View style={{ width: "12%", textAlign: "right" }}>
//                     <Text></Text>
//                   </View>

//                   <View style={{ width: "12%", textAlign: "right" }}>
//                     <Text style={{ fontWeight: "bold" }}>{currencyFormat(Math.abs(account.close_balance))}</Text>
//                   </View>
//                 </View>
//                 {(account.trans || [])
//                   .sort((a, b) => {
//                     return new Date(a?.transactionat).getTime() - new Date(b?.transactionat).getTime() || a?.code - b?.code;
//                   })
//                   .map((transaction, o) => (
//                     <View key={o}>
//                       {(transaction.at_detail || []).map((trans, i) => {
//                         let debit = trans?.debit ? parseFloat(trans.debit) : 0;
//                         let credit = trans?.credit ? parseFloat(trans.credit) : 0;

//                         if (debit > 0) {
//                           temp_saldo = parseFloat(temp_saldo) + debit;
//                         }

//                         if (credit > 0) {
//                           temp_saldo = parseFloat(temp_saldo) - credit;
//                         }

//                         const isMinusDebit = account?.type === "DEBIT" && temp_saldo < 0;

//                         const isMinusCredit = account?.type === "CREDIT" && temp_saldo > 0;

//                         return (
//                           <View
//                             key={i}
//                             style={{
//                               flexDirection: "row",
//                               width: "100%",
//                               padding: 6,
//                               borderBottomWidth: 1,
//                               borderBottomColor: "#e0e0e0",
//                             }}
//                           >
//                             <View style={{ width: "12%" }}>
//                               <Text>{handleValidDate(transaction?.transactionat, "DD/MM/YYYY")}</Text>
//                             </View>

//                             <View style={{ width: "18%" }}>
//                               <Text>{transaction?.transaction_no}</Text>
//                             </View>

//                             <View style={{ width: "34%" }}>
//                               <Text>{transaction?.description}</Text>
//                             </View>

//                             <View style={{ width: "12%", textAlign: "right" }}>
//                               <Text>{debit > 0 ? currencyFormat(debit) : "0"}</Text>
//                             </View>

//                             <View style={{ width: "12%", textAlign: "right" }}>
//                               <Text>{credit > 0 ? currencyFormat(credit) : "0"}</Text>
//                             </View>

//                             <View style={{ width: "12%", textAlign: "right" }}>
//                               <Text>{isMinusDebit || isMinusCredit ? `( ${currencyFormat(Math.abs(temp_saldo))} )` : currencyFormat(Math.abs(temp_saldo))}</Text>
//                             </View>
//                           </View>
//                         );
//                       })}
//                     </View>
//                   ))}
//                 <View
//                   style={{
//                     flexDirection: "row",
//                     width: "100%",
//                     padding: 6,
//                     borderBottomWidth: 1,
//                     borderBottomColor: "#e0e0e0",
//                   }}
//                 >
//                   <View style={{ width: "12%" }}>
//                     <Text></Text>
//                   </View>

//                   <View style={{ width: "18%" }}>
//                     <Text></Text>
//                   </View>

//                   <View style={{ width: "34%", textAlign: "right" }}>
//                     <Text>{`((${account.code}) ${account.name.trimStart()}) | Saldo Akhir`}</Text>
//                   </View>
//                   <View style={{ width: "12%", textAlign: "right" }}>
//                     <Text style={{ fontWeight: "bold" }}>{account.type === "DEBIT" && account.balance > 0 ? currencyFormat(account.balance) : "0"}</Text>
//                   </View>

//                   <View style={{ width: "12%", textAlign: "right" }}>
//                     <Text style={{ fontWeight: "bold" }}>{account.type === "DEBIT" && account.balance > 0 ? "0" : account.balance === 0 ? "0" : currencyFormat(Math.abs(account.balance))}</Text>
//                   </View>

//                   <View style={{ width: "12%", textAlign: "right" }}>
//                     <Text style={{ fontWeight: "bold" }}>{account.type === "DEBIT" && account.balance > 0 ? currencyFormat(Math.abs(account.balance)) : account.balance === 0 ? "0" : `( ${currencyFormat(Math.abs(account.balance))} )`}</Text>
//                   </View>
//                 </View>

//                 <View style={{ height: 20 }} />
//               </View>
//             );
//           })}
//         </View>
//         <View fixed style={{ position: "absolute", bottom: 30, left: 30, right: 30 }}>
//           <View>
//             <Text>*Menampilkan total dari 18726 baris transaksi</Text>
//             <View style={{ height: 1, width: "100%", backgroundColor: "#000000", marginTop: 10, marginBottom: 10 }}></View>
//             <View style={{ flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
//               <Text>Buku Besar : PT Hikmah Alam Sentosa 01/01/2024 - 31/03/2024</Text>
//               <Text render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`} />
//             </View>
//           </View>
//         </View>
//       </Page>
//     </Document>
//   );
// };

// const Export = ({ data = [] }) => {
//   const handleExport = async () => {
//     const blob = await pdf(<BalanceSheetPDF data={data} />).toBlob();

//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = "Laporan_Laba_Rugi.pdf";
//     link.click();
//   };

//   return (
//     <button onClick={handleExport} className="btn btn-success">
//       Export
//     </button>
//   );
// };

// export default Export;
import React, { useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const ExportPDF = ({ data }) => {
  const ref = useRef();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [pdfBlob, setPdfBlob] = useState(null);

  const PAGE_WIDTH = 1122;
  const PAGE_HEIGHT = 794;
  const PAGE_PADDING = 30;

  const currencyFormat = (num) => parseFloat(num || 0).toLocaleString("id-ID");

  const handleValidDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return `${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1).toString().padStart(2, "0")}/${d.getFullYear()}`;
  };

  const buildPages = () => {
    const pages = [];
    let currentPage = [];
    let currentHeight = 0;
    const CONTENT_HEIGHT = PAGE_HEIGHT - PAGE_PADDING * 2;

    const pushRow = (element, type) => {
      const h = 34;
      if (currentHeight + h > CONTENT_HEIGHT) {
        pages.push(currentPage);
        currentPage = [];
        currentHeight = 0;
      }
      currentPage.push(element);
      currentHeight += h;
    };

    data
      .filter((account) => account.isChecked)
      .forEach((account) => {
        let temp_saldo = account.close_balance;

        // Account header
        pushRow(
          <div key={`acc-${account.id}`} style={{ padding: 8, backgroundColor: "#f1f1f1", fontWeight: "bold" }}>
            ({account.code}) {account.name}
          </div>,
          "account",
        );

        // Saldo Awal
        pushRow(
          <div
            key={`saldoawal-${account.id}`}
            style={{
              display: "flex",
              width: "100%",
              padding: 8,
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <div style={{ width: "12%", fontWeight: "bold" }}>{handleValidDate(account.closeat)}</div>
            <div style={{ width: "18%", fontWeight: "bold" }}>Saldo Awal</div>
            <div style={{ width: "34%" }}></div>
            <div style={{ width: "12%" }}></div>
            <div style={{ width: "12%" }}></div>
            <div style={{ width: "12%", textAlign: "right", fontWeight: "bold" }}>{currencyFormat(Math.abs(account.close_balance))}</div>
          </div>,
          "saldo",
        );

        // Transactions
        (account.trans || [])
          .sort((a, b) => new Date(a.transactionat) - new Date(b.transactionat))
          .forEach((transaction) =>
            (transaction.at_detail || []).forEach((trans, i) => {
              const debit = trans.debit ? parseFloat(trans.debit) : 0;
              const credit = trans.credit ? parseFloat(trans.credit) : 0;
              temp_saldo += debit - credit;
              const isMinusDebit = account.type === "DEBIT" && temp_saldo < 0;
              const isMinusCredit = account.type === "CREDIT" && temp_saldo > 0;

              pushRow(
                <div
                  key={`${transaction.transaction_no}-${i}`}
                  style={{
                    display: "flex",
                    width: "100%",
                    padding: 6,
                    borderBottom: "1px solid #e0e0e0",
                    breakInside: "avoid",
                  }}
                >
                  <div style={{ width: "12%" }}>{handleValidDate(transaction.transactionat)}</div>
                  <div style={{ width: "18%" }}>{transaction.transaction_no}</div>
                  <div style={{ width: "34%" }}>
                    {transaction?.description}
                    <ul style={{ marginLeft: "-20px" }}>
                      {(transaction?.at_purchase?.purchase_detail || []).map((purchase, pi) => {
                        return <li className="mb-0 fs-11" key={pi}>{purchase.cvl_account} - {purchase.name} {currencyFormat(purchase.quantity)} * Rp {currencyFormat(purchase.amount)} = {currencyFormat(purchase.amount_total)} </li>
                      })}
                    </ul>
                  </div>
                  <div style={{ width: "12%", textAlign: "right" }}>{debit > 0 ? currencyFormat(debit) : "0"}</div>
                  <div style={{ width: "12%", textAlign: "right" }}>{credit > 0 ? currencyFormat(credit) : "0"}</div>
                  <div style={{ width: "12%", textAlign: "right" }}>{isMinusDebit || isMinusCredit ? `( ${currencyFormat(Math.abs(temp_saldo))} )` : currencyFormat(Math.abs(temp_saldo))}</div>
                </div>,
                "row",
              );
            }),
          );

        // Saldo Akhir
        pushRow(
          <div
            key={`saldoakhir-${account.id}`}
            style={{
              display: "flex",
              width: "100%",
              padding: 6,
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <div style={{ width: "12%" }}></div>
            <div style={{ width: "18%" }}></div>
            <div style={{ width: "34%", textAlign: "right" }}>{`((${account.code}) ${account.name}) | Saldo Akhir`}</div>
            <div style={{ width: "12%", textAlign: "right", fontWeight: "bold" }}>{account.type === "DEBIT" && account.balance > 0 ? currencyFormat(account.balance) : "0"}</div>
            <div style={{ width: "12%", textAlign: "right", fontWeight: "bold" }}>{account.type === "DEBIT" && account.balance > 0 ? "0" : account.balance === 0 ? "0" : currencyFormat(Math.abs(account.balance))}</div>
            <div style={{ width: "12%", textAlign: "right", fontWeight: "bold" }}>{account.type === "DEBIT" && account.balance > 0 ? currencyFormat(Math.abs(account.balance)) : account.balance === 0 ? "0" : `( ${currencyFormat(Math.abs(account.balance))} )`}</div>
          </div>,
          "saldo",
        );

        pushRow(<div key={`space-${account.id}`} style={{ height: 20 }} />, "space");
      });

    if (currentPage.length) pages.push(currentPage);
    return pages;
  };

  const handleExport = async () => {
    try {
      setLoading(true);
      setPdfBlob(null);

      const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "landscape" });
      const pageDivs = document.querySelectorAll(".pdf-page");

      setTotalPage(pageDivs.length);

      for (let i = 0; i < pageDivs.length; i++) {
        setCurrentPage(i + 1);

        await new Promise((r) => setTimeout(r, 10));

        const canvas = await html2canvas(pageDivs[i], {
          scale: 0.8,
          useCORS: true,
        });

        const imgData = canvas.toDataURL("image/png");
        const imgProps = pdf.getImageProperties(imgData);

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        if (i > 0) pdf.addPage();

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

        canvas.width = 0;
        canvas.height = 0;
      }

      // pdf.save("Laporan_Buku_Besar.pdf");
      const blob = pdf.output("blob");
      setPdfBlob(blob);
    } catch (err) {
      console.error("Export PDF Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const pages = buildPages();

  return (
    <>
      <div
        style={{
          position: "fixed",
          left: "-99999px",
          top: 0,
        }}
        ref={ref}
      >
        {pages.map((page, i) => (
          <div
            key={i}
            className="pdf-page"
            style={{
              width: PAGE_WIDTH,
              minHeight: PAGE_HEIGHT,
              padding: PAGE_PADDING,
              boxSizing: "border-box",
              pageBreakAfter: "always",
              fontFamily: "Helvetica",
              fontSize: 10,
            }}
          >
            <div style={{ marginBottom: 20, fontWeight: "bold" }}>
              <div>PT HIKMAH ALAM SENTOSA</div>
              <div>NERACA</div>
              <div>per tanggal 31/12/2024</div>
              <div style={{ fontSize: 8 }}>(dalam IDR)</div>
            </div>

            {/* Table Header */}
            <div
              style={{
                display: "flex",
                width: "100%",
                padding: 6,
                backgroundColor: "#00c7ff",
                color: "#fff",
                marginBottom: 4,
                fontWeight: "bold",
              }}
            >
              <div style={{ width: "12%" }}>Tanggal</div>
              <div style={{ width: "18%" }}>Nomor</div>
              <div style={{ width: "34%" }}>Keterangan</div>
              <div style={{ width: "12%", textAlign: "right" }}>Debit</div>
              <div style={{ width: "12%", textAlign: "right" }}>Kredit</div>
              <div style={{ width: "12%", textAlign: "right" }}>Saldo</div>
            </div>

            {page}

            <div style={{ marginTop: 20 }}>
              <div style={{ height: 1, width: "100%", backgroundColor: "#000", marginTop: 10, marginBottom: 10 }} />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>Buku Besar : PT Hikmah Alam Sentosa 01/01/2024 - 31/03/2024</div>
                <div>Page {i + 1}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button
        disabled={loading}
        onClick={() => {
          if (pdfBlob) {
            const url = URL.createObjectURL(pdfBlob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Laporan_Buku_Besar.pdf";
            a.click();
          } else {
            handleExport();
          }
        }}
        className="btn btn-success"
        style={{
          cursor: loading ? "not-allowed" : "pointer",
        }}
      >
        {loading ? `Generating Page ${currentPage} / ${totalPage}` : pdfBlob ? "Download PDF" : "Generate PDF"}
      </button>
    </>
  );
};

export default ExportPDF;
